// fitting-quiz.js
$(function () {
  let emailRegex =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    // :: global block objects ::
  let intro_block = $("[data-block='quiz-intro']");
  let type_block = $("[data-block='quiz-type-select']");
  let continue_block = $("[data-block='quiz-continue']");
  let size_block = $("[data-block='quiz-size-select']");
  let age_block = $("[data-block='quiz-age-select']");
  let brand_block = $("[data-block='quiz-brand-select']");
  let comfort_block = $("[data-block='quiz-comfort-select']");
  let jiggle_block = $("[data-block='quiz-jiggle-select']");
  let shape_block = $("[data-block='quiz-shape-select']");
  let mom_block = $("[data-block='quiz-mom-options']");
  let fit_block = $("[data-block='quiz-fit-select']");
  let email_block = $('[data-block="quiz-email"]');
  let $quizResult = $('.quiz_result')

  let quiz_btns = ".button.quiz--button-next, .button.quiz--button-skip";

  // :: global ans log ::
  mtdev.showAns = function () {
    // console.log(`data`, mtdev.quiz);
  };

  // :: global change step ::
  mtdev.updateStep = (oldStep, updatedStep, time = 300) => {
    setTimeout(() => {
      $("[data-block='" + oldStep + "']").attr("data-hidden", true);
      $("[data-block='" + updatedStep + "']").attr("data-hidden", "");

      let nextStepObj = $("[data-block='" + updatedStep + "']");
      let upcomingStep = nextStepObj.attr("data-nextslide") || "";

      mtdev.quiz.stepsdata = {
        previous: oldStep,
        current: updatedStep,
        next: upcomingStep,
      };

      mtdev.updateProgress();
      // A11y: announce the new step + focus its first heading/control so
      // screen reader users know where they are in the quiz.
      mtdev.announceStep(updatedStep);
    }, time / 2);
  };

  // A11y: shared polite live region for step + progress announcements.
  mtdev.getQuizLiveRegion = () => {
    let region = document.getElementById('QuizA11yStatus');
    if (!region) {
      region = document.createElement('div');
      region.id = 'QuizA11yStatus';
      region.className = 'visually-hidden';
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('aria-atomic', 'true');
      document.body.appendChild(region);
    }
    return region;
  };

  mtdev.announceStep = (stepName) => {
    const stepObj = document.querySelector("[data-block='" + stepName + "']");
    if (!stepObj) return;
    let label = stepObj.getAttribute('aria-label') || '';
    if (!label) {
      const heading = stepObj.querySelector('h1, h2, h3, [data-quiz-question]');
      if (heading) label = heading.textContent.trim();
    }
    const stepIndex = stepObj.getAttribute('data-stepindex');
    const total = (mtdev.quiz && (mtdev.quiz.answers.type === 'everyday' || mtdev.quiz.answers.type === 'sports')) ? 5 : 4;
    const prefix = stepIndex ? ('Question ' + stepIndex + ' of ' + total + '. ') : '';
    mtdev.getQuizLiveRegion().textContent = prefix + (label || stepName);

    // Move focus into the new step container so keyboard users follow along.
    if (!stepObj.hasAttribute('tabindex')) stepObj.setAttribute('tabindex', '-1');
    try { stepObj.focus({ preventScroll: false }); } catch (e) { /* noop */ }
  };

  mtdev.updateProgress = () => {
    let totalSteps = 4;
    if (
      mtdev.quiz.answers.type == "everyday" ||
      mtdev.quiz.answers.type == "sports"
    ) {
      totalSteps = 5;
    }
    let currentStep = mtdev.quiz.stepsdata.current;
    let currentStepObj = $("[data-block='" + currentStep + "']");

    if (currentStepObj.attr("data-stepindex")) {
      let stepIndex = currentStepObj.attr("data-stepindex");
      stepIndex = parseInt(stepIndex);
      let progressPart = 100 / totalSteps;
      let pct = Math.round(progressPart * stepIndex);
      $(".quiz-progress .progress").css(
        "width",
        progressPart * stepIndex + "%"
      );
      $(".quiz-progress .progress-count").text(
        "Question " + stepIndex + "/" + totalSteps
      );
      // A11y: expose progress as a progressbar.
      $(".quiz-progress")
        .attr("role", "progressbar")
        .attr("aria-valuemin", 0)
        .attr("aria-valuemax", 100)
        .attr("aria-valuenow", pct)
        .attr("aria-valuetext", "Question " + stepIndex + " of " + totalSteps);
    } else {
      $(".quiz-progress .progress").removeAttr("style");
      $(".quiz-progress .progress-count").text("");
      $(".quiz-progress").removeAttr("role aria-valuemin aria-valuemax aria-valuenow aria-valuetext");
    }

    if (
      mtdev.quiz.stepsdata.current == "quiz-intro" ||
      mtdev.quiz.stepsdata.current == "quiz-continue"
    ) {
      $(".quiz-progress").addClass("hidden-progress");
    } else {
      $(".quiz-progress").removeClass("hidden-progress");
    }

    if (
      mtdev.quiz.stepsdata.current == "quiz-continue" ||
      mtdev.quiz.stepsdata.current == "quiz-email" ||
      mtdev.quiz.stepsdata.current == "everyday" ||
      mtdev.quiz.stepsdata.current == "sports" ||
      mtdev.quiz.stepsdata.current == "eveningwear" ||
      mtdev.quiz.stepsdata.current == "motherhood"
    ) {
      $(".quiz-progress").removeClass("show-progress");
    } else {
      $(".quiz-progress").addClass("show-progress");
    }
  };

  mtdev.enableLoading = function (show, time = 300) {
    let speed = time / 3;
    if(show){
      $(".loader").fadeIn(speed);
    } else {
      $(".loader").fadeOut(speed);
    }
  };

  mtdev.fetchProducts = () => {
    mtdev.enableLoading(1);
    const values = Object.values(mtdev.quiz.ans);
    if(values.length === 0) {
      alert('No options selected');
      return;
    }

    console.log("values.length:", values.length);

    var coll_url = '/collections/all/' + values.join('+') + '?view=quizresult';
    console.log("coll_url: ", coll_url);
    fetch(coll_url).then(res => res.text()).then(data => {
      const body = mtdev.stringToHTML(data);
      const items = body.querySelectorAll('.quiz_result');
      let prod_json = null;
      $quizResult.find('.product--card').attr('data-hidden', true);
      console.log("data:: ", data);
      if(items.length === 0){
        $quizResult.find('.product--card.no-result').attr('data-hidden', '');
      } else {
        prod_json = JSON.parse(body.querySelector('script').innerHTML);
        console.log('prod_json', prod_json);
        $quizResult.html(body.querySelector('.quiz_result').innerHTML);
        $quizResult.find('.product--card.has-result').attr('data-hidden', '');

        if(mtdev.quiz.ans.band && mtdev.quiz.ans.cup && prod_json.variants.length > 1){
          let band_pos = prod_json.options.indexOf('Band Size');
          let cup_pos = prod_json.options.indexOf('Cup Size');
          if(band_pos != -1 && cup_pos != -1){
            band_pos = 'option' + (band_pos + 1);
            cup_pos = 'option' + (cup_pos + 1);
            const band = mtdev.quiz.ans.band.split('_')[1];
            const cup = mtdev.quiz.ans.cup.split('_')[1];

            const variant = prod_json.variants.filter(v => v[band_pos] === band && v[cup_pos] === cup)[0];
            if(variant){
              let href = (prod_json.url || ('/products/' + prod_json.handle))  + '?variant=' + variant.id;
              $quizResult.find('.quiz--button-view-prod').attr('href', href);
            }
          }
        }
      }

      $('[data-block]').attr('data-hidden', true);
      $quizResult.attr('data-hidden', '');
      mtdev.enableLoading(0);
    }).catch(err => {
      alert('Something went wrong. please reload the page & try again');
      console.error('Error', err);
    });

  }

  // :: main section js ::
  $(quiz_btns).on("click", function () {
    let time = mtdev.loaderTimer * 1000;
    let currentStepObj = $(this).parents("[data-block]");
    let currentStepName = currentStepObj.attr("data-block");
    let nextStepName =
      currentStepObj.attr("data-nextslide") || $(this).attr("data-slideto");

    let isSkip = this.className.includes('quiz--button-skip');
    let step_name_dcase = currentStepName.toLowerCase();

    switch(step_name_dcase){
      case 'quiz-size-select':
          if(isSkip){
            delete mtdev.quiz.answers.band;
            delete mtdev.quiz.answers.cup;
            delete mtdev.quiz.ans.band;
            delete mtdev.quiz.ans.cup;
          } else {
            var band = mtdev.quiz.answers.band;
            var cup = mtdev.quiz.answers.cup;
            if(band && !cup){
              alert('Please select cup');
              return;
            }
            if(cup && !band){
              alert('Please select band');
              return;
            }
          }
          break;

      case 'quiz-age-select':
        if(isSkip){
          delete mtdev.quiz.answers.age;
          delete mtdev.quiz.ans.age;
        }
        break;

      case 'quiz-brand-select':
        if(isSkip){
          delete mtdev.quiz.answers.brand;
          delete mtdev.quiz.ans.brand;
        }
        break;
    }

    if (
      $(this).attr("data-validates") &&
      $(this).attr("data-validates") != ""
    ) {
      let toValidate = $(this).attr("data-validates");
      let elm = $('[name="' + toValidate + '"]');
      let val;
      if (elm.attr("type") == "checkbox" || elm.attr("type") == "radio") {
        val = $('[name="' + toValidate + '"]:checked').val();
        if (!val) {
          alert("Please select any option.");
          return false;
        }
      } else if (elm.attr("type") == "email") {
        val = $('[name="' + toValidate + '"]').val();
        if (!val) {
          $(".email-error-message").text("Email is required!");
          elm.focus();
          return false;
        } else if (val != "") {
          if (!val.match(emailRegex)) {
            $(".email-error-message").text("Please enter valid email to continue.");
            elm.focus();
            return false;
          } else {
            mtdev.fetchProducts();

            $(".email-error-message").text("");
            let d = $("form", email_block).serialize();
            jQuery.ajax({
              type: 'POST',
              async: true,
              url: '/contact',
              data: d,
              beforeSend: function() {
                console.log('sending form');
                // mtdev.enableLoading(1);
              },
              error: function(t) {
                console.log('error occured!', t);
                //alert('Something went wrong. please reload the page & try again');
                return false;
              },
              success: function(res) {
                console.log('Success! response:', res);
                // mtdev.fetchProducts();
              }
            }); 

            return false;
          }
        }
      } else {
        val = $('[name="' + toValidate + '"]').val();
        if (!val) {
          alert("Please enter value.");
          elm.focus();
          return false;
        }
      }
    }

    if (nextStepName) {
      mtdev.showLoader(time);
      mtdev.updateStep(currentStepName, nextStepName, time);
    } else {
      console.error("Error: next step is undefined!");
    }

    mtdev.quiz.steps_flow && mtdev.quiz.steps_flow.push(nextStepName);
    mtdev.showAns();
  });

  $(".quiz--button-back").on("click", function () {
    let time = mtdev.loaderTimer * 1000;

    if (mtdev.quiz.steps_flow && mtdev.quiz.steps_flow.length > 1) {
      let currentStep = mtdev.quiz.stepsdata.current;
      let index = mtdev.quiz.steps_flow.indexOf(currentStep);
      let newPrevStep = mtdev.quiz.steps_flow[index - 1] || "";
      let prevStep = mtdev.quiz.steps_flow[index - 2] || "";

      if (newPrevStep && newPrevStep != "") {
        mtdev.showLoader(time);
        setTimeout(() => {
          $("[data-block='" + currentStep + "']").attr("data-hidden", true);
          $("[data-block='" + newPrevStep + "']").attr("data-hidden", "");
          mtdev.updateProgress();
        }, time / 2);

        mtdev.quiz.stepsdata = {
          previous: prevStep,
          current: newPrevStep,
          next: currentStep,
        };
      }
    }

    mtdev.showAns();
  });

  // :: global show loader ::
  mtdev.showLoader = function (time = 300) {
    let speed = time / 3;
    $(".loader").fadeIn(speed).delay(speed).fadeOut(speed);
  };


  // :: initial step selection ::
  intro_block.attr("data-nextslide", "quiz-type-select");
  type_block.attr("data-nextslide", "quiz-continue");
  continue_block.attr("data-nextslide", "quiz-size-select");
  mtdev.quiz.steps_flow = ["quiz-intro"];

  setTimeout(() => {
    console.clear();
  }, 1000);

  // :: type-select page ::
  $('[name="type_selection"]').on("change", function () {
    mtdev.quiz.answers.type = $(this).val();
    mtdev.quiz.ans.type = this.dataset.value;

    // do something on next step/s
    $("[data-optionsfor]", continue_block).attr("data-hidden", true);
    $(
      "[data-optionsfor='" + mtdev.quiz.answers.type + "']",
      continue_block
    ).attr("data-hidden", "");

    // on comfort select step
    $("[data-optionsfor]", comfort_block).attr("data-hidden", true);
    $(
      "[data-optionsfor='" + mtdev.quiz.answers.type + "']",
      comfort_block
    ).attr("data-hidden", "");

    switch (mtdev.quiz.answers.type) {
      case "everyday":
        // set step sequence
        size_block.attr({
          "data-nextslide": "quiz-age-select",
          "data-stepindex": 1,
        });
        age_block.attr({
          "data-nextslide": "quiz-comfort-select",
          "data-stepindex": 2,
        });
        // brand_block.attr({
        //   "data-nextslide": "quiz-comfort-select",
        //   "data-stepindex": 3,
        // });
        comfort_block.attr({
          "data-nextslide": "quiz-shape-select",
          "data-stepindex": 3,
        });
        shape_block.attr({
          "data-nextslide": "quiz-email",
          "data-stepindex": 4,
        });
        email_block.attr({ "data-nextslide": mtdev.quiz.answers.type });

        // on age select step
        $("[data-optionsfor]", age_block).attr("data-hidden", true);
        $("[data-optionsfor='everyday, sports']", age_block).attr(
          "data-hidden",
          ""
        );

        mtdev.stepcount = 5;

        break;

      case "sports":
        // set step sequence
        size_block.attr({
          "data-nextslide": "quiz-age-select",
          "data-stepindex": 1,
        });
        age_block.attr({
          "data-nextslide": "quiz-comfort-select",
          "data-stepindex": 2,
        });
        comfort_block.attr({
          "data-nextslide": "quiz-jiggle-select",
          "data-stepindex": 3,
        });
        jiggle_block.attr({
          "data-nextslide": "quiz-shape-select",
          "data-stepindex": 4,
        });
        shape_block.attr({
          "data-nextslide": "quiz-email",
          "data-stepindex": 5,
        });
        email_block.attr({ "data-nextslide": mtdev.quiz.answers.type });

        // on age select step
        $("[data-optionsfor]", age_block).attr("data-hidden", true);
        $("[data-optionsfor='everyday, sports']", age_block).attr(
          "data-hidden",
          ""
        );

        // on age select step
        $("[data-optionsfor]", comfort_block).attr("data-hidden", true);
        $("[data-optionsfor='sports']", comfort_block).attr("data-hidden", "");

        mtdev.stepcount = 5;

        break;

      case "eveningwear":
        // set step sequence
        size_block.attr({
          "data-nextslide": "quiz-comfort-select",
          "data-stepindex": 1,
        });
        comfort_block.attr({
          "data-nextslide": "quiz-fit-select",
          "data-stepindex": 2,
        });
        fit_block.attr({
          "data-nextslide": "quiz-shape-select",
          "data-stepindex": 3,
        });
        shape_block.attr({
          "data-nextslide": "quiz-email",
          "data-stepindex": 4,
        });
        email_block.attr({ "data-nextslide": mtdev.quiz.answers.type });

        mtdev.stepcount = 4;

        break;

      case "motherhood":
        // set step sequence
        size_block.attr({
          "data-nextslide": "quiz-age-select",
          "data-stepindex": 1,
        });
        age_block.attr({
          "data-nextslide": "quiz-comfort-select",
          "data-stepindex": 2,
        });
        comfort_block.attr({
          "data-nextslide": "quiz-mom-options",
          "data-stepindex": 3,
        });
        mom_block.attr({ "data-nextslide": "quiz-email", "data-stepindex": 4 });
        email_block.attr({ "data-nextslide": mtdev.quiz.answers.type });

        // on age select step
        $("[data-optionsfor]", age_block).attr("data-hidden", true);
        $("[data-optionsfor='motherhood']", age_block).attr("data-hidden", "");

        mtdev.stepcount = 4;

        break;

      default:
        //nothing here
        break;
    }

    // // also, trigger value change for range slider on jiggle-select step
    // console.log("jiggle_range should trigger")
    // $("#jiggle_range").trigger("change");

    $(".quiz--button-next", type_block).click();

    // log
    mtdev.showAns();
  });

  // :: age-select step ::
  $('[name="age_selection"]').on("change", function () {
    mtdev.quiz.answers.age = $(this).val();
    mtdev.quiz.ans.age = this.dataset.value;
  });

  // :: jiggle-select step ::
  $("#jiggle_range").on("change", function () {
    let jiggle_value;
    if ($(this).val() == 1) {
      jiggle_value = "jiggle_mild";
    } else if ($(this).val() == 2) {
      jiggle_value = "jiggle_moderate";
    } else if ($(this).val() == 3) {
      jiggle_value = "jiggle_extreme";
    }
    mtdev.quiz.answers.jiggle = jiggle_value;
    mtdev.quiz.ans.jiggle = jiggle_value;

    // do something on next step/s
    $("[data-optionsfor]", shape_block).attr("data-hidden", true);
    $("[data-optionsfor='" + jiggle_value + "']", shape_block).attr(
      "data-hidden",
      ""
    );

    // log
    mtdev.showAns();
  });

  // :: comfort-select step ::
  $('[name="comfort_selection"]').on("change", function () {
    mtdev.quiz.answers.comfort = $(this).val();
    mtdev.quiz.ans.comfort = this.dataset.value;

    // decide next step name
    let next_block = shape_block;
    if (mtdev.quiz.answers.type == "motherhood") {
      next_block = mom_block;
    } else if (mtdev.quiz.answers.type == "eveningwear") {
      next_block = fit_block;
    }

    // do something on next step/s
    $("[data-optionsfor]", next_block).attr("data-hidden", true);
    if (mtdev.quiz.answers.type == "eveningwear") {
      $("[data-optionsfor='evening_fit']", next_block).attr("data-hidden", "");
    } else {
      $(
        "[data-optionsfor='" + mtdev.quiz.answers.comfort + "']",
        next_block
      ).attr("data-hidden", "");
    }

    // also, trigger value change for range slider on jiggle-select step
    if (mtdev.quiz.answers.type == "sports") {
      $("#jiggle_range").trigger("change");
    }

    $(".quiz--button-next", comfort_block).click();

    // log
    mtdev.showAns();
  });

  // :: fit-select step ::
  $('[name="fit_selection"]').on("change", function () {
    mtdev.quiz.answers.fit = $(this).val();
    mtdev.quiz.ans.fit = this.dataset.value;

    // some things on next step
    $("[data-optionsfor]", shape_block).attr("data-hidden", true);
    $("[data-optionsfor='" + mtdev.quiz.answers.fit + "']", shape_block).attr(
      "data-hidden",
      ""
    );

    $(".quiz--button-next", fit_block).click();

    // log
    mtdev.showAns();
  });

  // :: shape-select step ::
  $('[name="shape_selection"]').on("change", function () {
    mtdev.quiz.answers.shape = $(this).val();
    mtdev.quiz.ans.shape = this.dataset.value;

    // do something on result step
    let result_block = $("[data-block='" + mtdev.quiz.answers.type + "']");
    $("[data-optionsfor]", result_block).attr("data-hidden", true);
    $(
      "[data-optionsfor='" + mtdev.quiz.answers.shape + "']",
      result_block
    ).attr("data-hidden", "");

    $(".quiz--button-next", shape_block).click();

    // log
    mtdev.showAns();
  });

  // :: mom-options step ::
  $('[name="mom_options"]').on("change", function () {
    mtdev.quiz.answers.momy = $(this).val();
    mtdev.quiz.ans.momy = this.dataset.value;

    // do something on result step
    let result_block = $("[data-block='" + mtdev.quiz.answers.type + "']");
    $("[data-optionsfor]", result_block).attr("data-hidden", true);
    $("[data-optionsfor='" + mtdev.quiz.answers.momy + "']", result_block).attr(
      "data-hidden",
      ""
    );

    $(".quiz--button-next", mom_block).click();

    // log
    mtdev.showAns();
  });

  // :: band, cup, brand select
  $('.template-fitting-quiz select.select__select').on('change', function(evt){
    var name = $(this).attr('name');
    if(name){
      var value = $(this).val();
      // if(value.indexOf('_') > -1){
      //   value = value.split('_')[1];
      // }
      mtdev.quiz.answers[name] = value;
      mtdev.quiz.ans[name] = value;
    }
  });
});
